// reducers/employee-onboarding/groups.js

export function groupsHasErrored(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_GROUPS_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function groupsIsLoading(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_GROUPS_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function groups(state = {}, action) {
  switch (action.type) {
    case 'ONBOARDING_GROUPS_FETCH_DATA_SUCCESS':
      return action.data;
    default:
      return state;
  }
}